import React from "react";
import { MFile, MInput, MLabel, ValidatedForm } from "components/forms";
import { dateHelper, payloadBuilder } from "libs";

export class Ricorso extends ValidatedForm {
  emptyFields = {
    dataPresentazioneDomanda: "",
    istitution: "",
    contactName: "",
    contactPhone: "",
    contactFax: "",
    contactEmail: "",
    contactPec: "",
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  state = {
    ...this.emptyFields,
    document: 0,
    defaultValues: { ...this.emptyFields },
  };

  FIELDS_GROUP = [
    [
      {
        id: "dataPresentazioneDomanda2",
        field: "dataPresentazioneDomanda",
        label: "Data di presentazione del ricorso",
        component: MInput,
        type: "date",
        className: "col-md-6",
      },
      {
        id: "istitution2",
        field: "istitution",
        label: "Sede giurisdizionale",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        field: "istanzaRiconoscimentoLabel",
        label: "Istanza di riconoscimento",
        component: MLabel,
        className: "col-md-12 pt-2 pb-0 mb-0",
      },
      {
        id: "istanzaRiconoscimentoFile",
        field: "document",
        component: MFile,
        value: this.props.enrollmentId,
        config: {
          endPoint: "/enrollment/attachment-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "istanzaRiconoscimento",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "ricorsoLabel",
        label: "Documentazione attestante il contenzioso",
        component: MLabel,
        className: "col-md-12 pt-2 pb-0 mb-0",
      },
      {
        id: "ricorsoFile",
        field: "document",
        component: MFile,
        value: this.props.enrollmentId,
        config: {
          endPoint: "/enrollment/attachment-file",
          fieldName: "document",
          maxFiles: 3,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "ricorso",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "optionalInfo",
        label: "Informazioni facoltative:",
        infoText:
          "Informazioni per la verifica dei dati ex articolo 15, comma 1, punto e della legge 183/2011. Recapiti della segreteria competente.",
        component: MLabel,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "contactName5",
        field: "contactName",
        label: "Denominazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "contactPhone5",
        field: "contactPhone",
        label: "Telefono",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "contactFax5",
        field: "contactFax",
        label: "Fax",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "contactEmail5",
        field: "contactEmail",
        label: "Email",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "contactPec5",
        field: "contactPec",
        label: "Pec",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
  ];

  validation = {
    dataPresentazioneDomanda: (value) => this.validateDataRicorso(value),
  };

  ERROR_MESSAGES = {
    dataPresentazioneDomanda: "Inserire una data valida",
  };

  validateDataRicorso = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const noFuture = dateHelper.noFuture(value);
    if (noFuture === false) {
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    return true;
  };

  componentDidMount() {
    const { defaultPayload, enrollmentId } = this.props;

    if (defaultPayload) {
      this.setState({
        ...defaultPayload,
        document: enrollmentId,
        defaultValues: {
          ...defaultPayload,
        },
      });
    } else {
      this.setState({
        document: enrollmentId,
        defaultValues: {
          ...this.state.defaultValues,
        },
      });
    }
  }

  onSubmit = () => {
    return this.checkValidation();
  };

  getPayload = () => {
    const payload = payloadBuilder(this.state);
    return payload;
  };

  render() {
    const { defaultValues, validationError } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        {code}
        {validationError && <div className="text-danger">{validationError}</div>}
      </>
    );
  }
}
